export const securityResources: Record<SecurityResourceKey, string> = {
  'security.created': 'Created',
  'security.accessKeyName': 'API Key Name',
  'security.oauthClientName': 'Oauth Client Name',
  'security.accessKeyId': 'API Key ID',
  'security.oauthClientId': 'Oauth Client ID',
  'security.active': 'Active',
  'security.reset': 'Reset',
  'security.resetAccessKey': 'Reset API Key',
  'security.resetClient': 'Reset Client Secret',
  'security.activateSwitch': '(De)activate',
  'security.configureKeys': 'Configured Keys',
  'security.configuredClients': 'Configured Oauth Clients',
  'security.createClient': 'Create Oauth Client',
  'security.createKey': 'Create Key',
  'security.keyName': 'Key Name',
  'security.clientName': 'Client Name',
  'security.create': 'Create',
  'security.secretWarning': 'Please save this information. Your secret will not be accessible again',
  'security.keyWarning': 'Please save this information. Your api key will not be accessible again',
  'security.oauthCreationMessage': 'New Oauth Client Created Successfully',
  'security.keyCreationMessage': 'New Api Key Created Successfully',
  'security.okMessage': 'Got it!',
  'security.resetWarning': 'This action is not reversible!',
  'security.resetButtonMessage': 'I know what I am doing. Reset Now.',
  'security.resetClientMessage':
    'Are you sure you want to reset this Oauth Client? This will break anything that is using the currently configured secret.',
  'security.resetKeyMessage':
    'Are you sure you want to reset this key? This will break anything that is using the currently configured key.',
  'security.deactivateKey': 'Deactivate Key',
  'security.reactivateKey': 'Reactivate Key',
  'security.deactivateClient': 'Deactivate Client',
  'security.reactivateClient': 'Reactivate Client',
};

export type SecurityResourceKey =
  | 'security.configuredClients'
  | 'security.accessKeyName'
  | 'security.oauthClientName'
  | 'security.oauthClientId'
  | 'security.resetAccessKey'
  | 'security.resetClient'
  | 'security.createClient'
  | 'security.clientName'
  | 'security.oauthCreationMessage'
  | 'security.keyCreationMessage'
  | 'security.created'
  | 'security.accessKeyId'
  | 'security.active'
  | 'security.reset'
  | 'security.activateSwitch'
  | 'security.configureKeys'
  | 'security.createKey'
  | 'security.keyName'
  | 'security.create'
  | 'security.secretWarning'
  | 'security.okMessage'
  | 'security.resetWarning'
  | 'security.resetButtonMessage'
  | 'security.resetKeyMessage'
  | 'security.deactivateKey'
  | 'security.reactivateKey'
  | 'security.deactivateClient'
  | 'security.reactivateClient'
  | 'security.resetClientMessage'
  | 'security.keyWarning';
